import moment from 'moment'

export const getTimeFrom = (dateTime) => {
	const daysDiff = moment().diff(dateTime, 'days')
	if (daysDiff !== 0) {
		const hoursDiff = moment().diff(dateTime.endOf('day'), 'hours')
		if (hoursDiff <= 24) {
			return 'hace un día'
		}
		
		return `${dateTime.endOf('day').fromNow()}`
	}
	return 'hoy'
}
  